import { render } from "./TopLevelVideoViewDetail.vue?vue&type=template&id=3f64829a"
import script from "./TopLevelVideoViewDetail.vue?vue&type=script&lang=js"
export * from "./TopLevelVideoViewDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/mbsm-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__